import { render, staticRenderFns } from "./showGoods.vue?vue&type=template&id=ea3f20ba&scoped=true"
import script from "./showGoods.vue?vue&type=script&lang=js"
export * from "./showGoods.vue?vue&type=script&lang=js"
import style0 from "./showGoods.vue?vue&type=style&index=0&id=ea3f20ba&prod&scoped=true&lang=css"
import style1 from "./showGoods.vue?vue&type=style&index=1&id=ea3f20ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3f20ba",
  null
  
)

export default component.exports